import React, { FC } from 'react';

import classNames from 'classnames';

import type { PromoOptionsStateProps } from './types';

import styles from './index.module.scss';

const PromoOptionsState: FC<PromoOptionsStateProps> = ({ children, className, isCompact = false, role, testId }) => (
  <div
    className={classNames(styles.state, { [styles.stateCompact]: isCompact }, className)}
    data-testid={testId}
    role={role}>
    {children}
  </div>
);

export default PromoOptionsState;
